// Privana-authored Safety presentation; tenant content is never a catalogue entry.
export default {
  "copy": {
    "accident": "Accident",
    "nearMiss": "Near miss",
    "propertyDamage": "Property damage",
    "memberComplaint": "Member complaint",
    "safeguardingConcern": "Safeguarding concern",
    "securityIncident": "Security incident",
    "vehicleIncident": "Vehicle incident",
    "environmentalIncident": "Environmental incident",
    "other": "Other",
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "critical": "Critical",
    "open": "Open",
    "investigating": "Investigating",
    "awaitingAction": "Awaiting action",
    "closed": "Closed",
    "member": "Member",
    "staff": "Staff",
    "contractor": "Contractor",
    "visitor": "Visitor",
    "guest": "Guest",
    "inProgress": "In progress",
    "completed": "Completed",
    "cancelled": "Cancelled",
    "photo": "Photo",
    "document": "Document",
    "witnessStatement": "Witness statement",
    "medical": "Medical",
    "clear": "Clear",
    "searching": "Searching...",
    "noMatchesFound": "No matches found.",
    "occurredTimeIn12HourFormat": "Occurred time in 12-hour format",
    "affectedPerson": "Affected person",
    "remove": "Remove",
    "personType": "Person type",
    "affectedMember": "Affected member",
    "searchMemberNameEmailOrNumber": "Search member name, email, or number",
    "affectedStaffMember": "Affected staff member",
    "searchStaffNameOrEmail": "Search staff name or email",
    "name": "Name",
    "nameIfKnown": "Name if known",
    "roleInIncident": "Role in incident",
    "affectedPersonBystanderDriver": "Affected person, bystander, driver...",
    "treatmentGiven": "Treatment given",
    "firstAidNoneAmbulance": "First aid, none, ambulance...",
    "injuryNotes": "Injury notes",
    "injuryDetailsOrAffectedPersonNotes": "Injury details or affected-person notes",
    "additionalNotes": "Additional notes",
    "sentToHospital": "Sent to hospital",
    "addAShortTitleForTheIncident": "Add a short title for the incident.",
    "addWhenTheIncidentHappened": "Add when the incident happened.",
    "unableToSaveIncident": "Unable to save incident.",
    "basicDetails": "Basic Details",
    "incidentType": "Incident type",
    "severity": "Severity",
    "status": "Status",
    "title": "Title",
    "eGSlipNearPoolSteps": "e.g. Slip near pool steps",
    "occurredDateTime": "Occurred date/time",
    "location": "Location",
    "poolDeckKitchenCarPark": "Pool deck, kitchen, car park...",
    "areaDepartment": "Area/department",
    "leisureFBGrounds": "Leisure, F&B, Grounds...",
    "description": "Description",
    "affectedPersonS": "Affected Person(s)",
    "addAffectedPerson": "Add affected person",
    "immediateAction": "Immediate Action",
    "firstAidAreaMadeSafeManagerNotified": "First aid, area made safe, manager notified...",
    "investigation": "Investigation",
    "investigationNotes": "Investigation notes",
    "rootCause": "Root cause",
    "correctiveActionSummary": "Corrective action summary",
    "cancel": "Cancel",
    "saving": "Saving...",
    "saveIncident": "Save incident",
    "addWitness": "Add witness",
    "searchMember": "Search member",
    "searchStaff": "Search staff",
    "injuryDescriptionNotes": "Injury description / notes",
    "witnessType": "Witness type",
    "phone": "Phone",
    "email": "Email",
    "statement": "Statement",
    "actionTitle": "Action title",
    "searchAssignee": "Search assignee",
    "actionDescription": "Action description",
    "save": "Save",
    "chooseAFileToUpload": "Choose a file to upload.",
    "unableToUploadAttachment": "Unable to upload attachment.",
    "uploadAttachment": "Upload attachment",
    "uploading": "Uploading...",
    "upload": "Upload",
    "unableToLoadIncident": "Unable to load incident.",
    "unableToOpenAttachment": "Unable to open attachment.",
    "unableToCloseIncident": "Unable to close incident.",
    "loadingIncident": "Loading incident...",
    "backToIncidentLog": "Back to incident log",
    "edit": "Edit",
    "closeIncident": "Close incident",
    "noDescriptionAddedYet": "No description added yet.",
    "locationLabel": "Location:",
    "area": "Area:",
    "affectedPersonLabel": "Affected person:",
    "add": "Add",
    "noNotesAdded": "No notes added.",
    "noAffectedPeopleAddedYet": "No affected people added yet.",
    "witnesses": "Witnesses",
    "noStatementAddedYet": "No statement added yet.",
    "noWitnessesAddedYet": "No witnesses added yet.",
    "followUpActions": "Follow-up actions",
    "noDescription": "No description.",
    "due": "Due:",
    "noDate": "No date",
    "markComplete": "Mark complete",
    "noFollowUpActionsYet": "No follow-up actions yet.",
    "attachments": "Attachments",
    "previewView": "Preview/View",
    "download": "Download",
    "linkedAttachment": "Linked attachment",
    "noAttachmentsUploadedYet": "No attachments uploaded yet.",
    "immediateActionLabel": "Immediate action:",
    "investigationNotesLabel": "Investigation notes:",
    "rootCauseLabel": "Root cause:",
    "correctiveAction": "Corrective action:",
    "auditHistory": "Audit history",
    "readOnlyAuditEntry": "Read-only audit entry",
    "noAuditEntriesYet": "No audit entries yet.",
    "closureNotesCorrectiveActionSummary": "Closure notes / corrective action summary",
    "optionalNotesOrCorrectiveActionSummary": "Optional notes or corrective action summary",
    "closing": "Closing...",
    "unableToLoadIncidents": "Unable to load incidents.",
    "editIncident": "Edit incident",
    "newIncident": "New incident",
    "openIncidents": "Open incidents",
    "closedThisMonth": "Closed this month",
    "incidentLog": "Incident Log",
    "newIncidentLabel": "New Incident",
    "searchIncidents": "Search incidents...",
    "allStatuses": "All statuses",
    "allTypes": "All types",
    "allSeverities": "All severities",
    "loadingIncidents": "Loading incidents...",
    "incidentNumber": "Incident number",
    "date": "Date",
    "type": "Type",
    "actions": "Actions",
    "view": "View",
    "noIncidentsFound": "No incidents found",
    "select": "Select...",
    "search": "Search...",
    "firstAid": "First aid",
    "fireMarshal": "Fire marshal",
    "foodHygiene": "Food hygiene",
    "safeguarding": "Safeguarding",
    "poolPlant": "Pool plant",
    "healthSafety": "Health & safety",
    "manualHandling": "Manual handling",
    "groundsMaintenance": "Grounds maintenance",
    "pesticideApplication": "Pesticide application",
    "machinery": "Machinery",
    "insurance": "Insurance",
    "methodStatement": "Method statement",
    "riskAssessment": "Risk assessment",
    "custom": "Custom",
    "active": "Active",
    "expiringSoon": "Expiring Soon",
    "expired": "Expired",
    "missingExpiry": "Missing Expiry",
    "archived": "Archived",
    "certificate": "Certificate",
    "addACertificationOrDocumentName": "Add a certification or document name.",
    "uploadsMustBe25MBOrSmaller": "Uploads must be 25MB or smaller.",
    "chooseAStaffMember": "Choose a staff member.",
    "chooseOrCreateAContractor": "Choose or create a contractor.",
    "addAHolderName": "Add a holder name.",
    "unableToSaveCertification": "Unable to save certification.",
    "editCertification": "Edit certification",
    "addCertification": "Add certification",
    "holder": "Holder",
    "holderType": "Holder type",
    "staffMember": "Staff member",
    "searchStaffLabel": "Search staff...",
    "searchContractors": "Search contractors...",
    "createContractor": "Create contractor",
    "companyNameIfNotListed": "Company name if not listed",
    "holderName": "Holder name",
    "nameOrOrganisation": "Name or organisation",
    "certificationDetails": "Certification details",
    "certificationName": "Certification name",
    "eGEmergencyFirstAidAtWork": "e.g. Emergency First Aid at Work",
    "issuingBody": "Issuing body",
    "trainingProviderOrAuthority": "Training provider or authority",
    "certificateNumber": "Certificate number",
    "issueDate": "Issue date",
    "expiryDate": "Expiry date",
    "notes": "Notes",
    "documents": "Documents",
    "viewDownload": "View / Download",
    "attachmentType": "Attachment type",
    "certificateUpload": "Certificate upload",
    "saveChanges": "Save changes",
    "certification": "Certification",
    "issuingBodyLabel": "Issuing Body",
    "expiryDateLabel": "Expiry Date",
    "attachment": "Attachment",
    "noFile": "No file",
    "archive": "Archive",
    "unableToLoadCertifications": "Unable to load certifications.",
    "unableToArchiveCertification": "Unable to archive certification.",
    "totalCertifications": "Total certifications",
    "expiringIn30Days": "Expiring in 30 days",
    "missingExpiryLabel": "Missing expiry",
    "contractorDocuments": "Contractor documents",
    "certificationRegister": "Certification Register",
    "addCertificationLabel": "Add Certification",
    "staffCertifications": "Staff Certifications",
    "contractorDocumentsLabel": "Contractor Documents",
    "documentLibrary": "Document Library",
    "searchHolderCertificationIssuingBody": "Search holder, certification, issuing body...",
    "allHolders": "All holders",
    "loadingCertifications": "Loading certifications...",
    "fileName": "File name",
    "uploadDate": "Upload date",
    "previewDownload": "Preview / Download",
    "noDocumentsUploadedYet": "No documents uploaded yet.",
    "noCertificationsAddedYet": "No certifications added yet",
    "archiveCertification": "Archive certification",
    "archiving": "Archiving...",
    "fireSafety": "Fire safety",
    "kitchen": "Kitchen",
    "clubhouse": "Clubhouse",
    "golfCourse": "Golf course",
    "pool": "Pool",
    "gym": "Gym",
    "maintenance": "Maintenance",
    "housekeeping": "Housekeeping",
    "security": "Security",
    "general": "General",
    "adHoc": "Ad hoc",
    "daily": "Daily",
    "weekly": "Weekly",
    "monthly": "Monthly",
    "quarterly": "Quarterly",
    "annually": "Annually",
    "text": "Text",
    "number": "Number",
    "signature": "Signature",
    "policy": "Policy",
    "procedure": "Procedure",
    "emergencyPlan": "Emergency plan",
    "firePlan": "Fire plan",
    "templates": "Templates",
    "checklistRuns": "Checklist Runs",
    "riskAssessments": "Risk Assessments",
    "complianceCalendar": "Compliance Calendar",
    "fireSafetyCheck": "Fire Safety Check",
    "firstAidKitCheck": "First Aid Kit Check",
    "kitchenOpeningCheck": "Kitchen Opening Check",
    "poolSafetyCheck": "Pool Safety Check",
    "golfCourseMachineryCheck": "Golf Course Machinery Check",
    "clubhouseWalkthrough": "Clubhouse Walkthrough",
    "pass": "Pass",
    "failed": "Failed",
    "mixed": "Mixed",
    "incomplete": "Incomplete",
    "inProgressLabel": "In Progress",
    "overdue": "Overdue",
    "moreActions": "More actions",
    "selectedTeamMember": "Selected team member",
    "searchByNameOrEmail": "Search by name or email",
    "noMatchingTeamMembers": "No matching team members.",
    "scheduledChecklist": "Scheduled Checklist",
    "dueLabel": "Due",
    "runNow": "Run now",
    "openRun": "Open run",
    "nothingHere": "Nothing here.",
    "viewMore": "View More",
    "close": "Close",
    "unableToSaveTemplate": "Unable to save template.",
    "editChecklistTemplate": "Edit checklist template",
    "createChecklistTemplate": "Create checklist template",
    "templateName": "Template name",
    "category": "Category",
    "areaDepartmentLabel": "Area / department",
    "frequency": "Frequency",
    "defaultDueTime": "Default due time",
    "hH": "HH",
    "mM": "MM",
    "activeTemplate": "Active template",
    "recurringSchedule": "Recurring schedule",
    "startDate": "Start date",
    "endDateOptional": "End date optional",
    "createRunXDaysBeforeDue": "Create run X days before due",
    "defaultAssignees": "Default assignees",
    "nextDuePreview": "Next due preview:",
    "savedAfterTemplateIsCreatedOrUpdated": "Saved after template is created or updated.",
    "automaticSchedulingIsOff": "Automatic scheduling is off.",
    "checklistItems": "Checklist items",
    "addItem": "Add item",
    "itemLabel": "Item label",
    "helpText": "Help text",
    "response": "Response",
    "required": "Required",
    "optional": "Optional",
    "photoOnFail": "Photo on fail",
    "noPhotoRule": "No photo rule",
    "saveTemplate": "Save template",
    "unableToStartRun": "Unable to start run.",
    "runChecklist": "Run Checklist",
    "template": "Template",
    "selectTemplate": "Select template",
    "assignTo": "Assign to",
    "dueDateTime": "Due date / time",
    "starting": "Starting...",
    "startRun": "Start run",
    "noEvidenceUploadedYet": "No evidence uploaded yet.",
    "checklistRun": "Checklist run",
    "loadingChecklistRun": "Loading checklist run...",
    "assignedTo": "Assigned to:",
    "unassigned": "Unassigned",
    "fail": "Fail",
    "pending": "Pending",
    "yes": "Yes",
    "no": "No",
    "evidence": "Evidence",
    "completeRun": "Complete Run",
    "editRiskAssessment": "Edit risk assessment",
    "addRiskAssessment": "Add Risk Assessment",
    "areaLabel": "Area",
    "owner": "Owner",
    "hazard": "Hazard",
    "whoMayBeHarmed": "Who may be harmed",
    "controls": "Controls",
    "likelihood15": "Likelihood (1-5)",
    "severity15": "Severity (1-5)",
    "riskScore": "Risk score",
    "reviewDate": "Review date",
    "furtherActionRequired": "Further action required",
    "noDescriptionLabel": "No description",
    "complete": "Complete",
    "noActionsAddedYet": "No actions added yet.",
    "dueDate": "Due date",
    "addAction": "Add action",
    "uploadEvidence": "Upload evidence",
    "saveRiskAssessment": "Save risk assessment",
    "uploadDocument": "Upload Document",
    "version": "Version",
    "file": "File",
    "unableToLoadSafetyChecklists": "Unable to load safety checklists.",
    "dueThisWeek": "Due this week",
    "dueThisMonth": "Due this month",
    "later": "Later",
    "archiveChecklistTemplate": "Archive checklist template",
    "archiveRiskAssessment": "Archive risk assessment",
    "archiveSafetyDocument": "Archive safety document",
    "unableToArchiveThisRecord": "Unable to archive this record.",
    "activeTemplates": "Active templates",
    "completedThisMonth": "Completed this month",
    "overdueChecks": "Overdue checks",
    "openRiskActions": "Open risk actions",
    "docsDueReview": "Docs due review",
    "safetyChecklists": "Safety Checklists",
    "createTemplate": "Create Template",
    "loadingOperationalSafetySystem": "Loading operational safety system...",
    "searchTemplates": "Search templates...",
    "allCategories": "All categories",
    "allFrequencies": "All frequencies",
    "activeOnly": "Active only",
    "allTemplates": "All templates",
    "archivedOnly": "Archived only",
    "schedule": "Schedule",
    "nextDue": "Next due",
    "items": "Items",
    "manual": "Manual",
    "inactive": "Inactive",
    "runChecklistLabel": "Run checklist",
    "noChecklistTemplatesYet": "No checklist templates yet",
    "searchRuns": "Search runs...",
    "allResults": "All results",
    "runNumber": "Run number",
    "assignedToLabel": "Assigned to",
    "result": "Result",
    "activeRisks": "Active risks",
    "highRisk": "High risk",
    "reviewDue": "Review due",
    "openActions": "Open actions",
    "searchRisks": "Search risks...",
    "allScores": "All scores",
    "highRiskOnly": "High risk only",
    "riskNumber": "Risk number",
    "searchDocuments": "Search documents...",
    "documentType": "Document type",
    "preview": "Preview",
    "noSafetyDocumentsUploadedYet": "No safety documents uploaded yet.",
    "archiveRecord": "Archive record",
    "everythingLooksHealthy": "Everything looks healthy.",
    "aFewItemsNeedAttention": "A few items need attention.",
    "severalComplianceAreasNeedReview": "Several compliance areas need review.",
    "immediateSafetyAttentionRequired": "Immediate safety attention required.",
    "unableToLoadSafetyDashboard": "Unable to load safety dashboard.",
    "dashboardCouldNotLoad": "Dashboard could not load",
    "retry": "Retry",
    "safetyComplianceOverview": "Safety compliance overview",
    "criticalItems": "Critical items",
    "needsAttention": "Needs attention",
    "refreshed": "Refreshed",
    "overallComplianceScore": "Overall compliance score",
    "overdueChecklists": "Overdue checklists",
    "certsExpiring": "Certs expiring",
    "riskReviewsDue": "Risk reviews due",
    "policiesAndProcedures": "Policies and procedures",
    "attentionRequired": "Attention Required",
    "noUrgentSafetyActions": "No urgent safety actions",
    "recentActivity": "Recent Activity",
    "noRecentSafetyActivityYet": "No recent safety activity yet.",
    "incidentBreakdown": "Incident breakdown",
    "noIncidentsRecorded": "No incidents recorded.",
    "checklistHealth": "Checklist health",
    "passRate": "Pass rate",
    "certificationHealth": "Certification health",
    "valid": "Valid",
    "expiring": "Expiring",
    "riskDocumentHealth": "Risk & document health",
    "highRisks": "High risks",
    "loadingDashboard": "Loading Dashboard...",
    "loadingIncidentLog": "Loading Incident Log...",
    "loadingCertificationsLabel": "Loading Certifications...",
    "loadingChecklists": "Loading Checklists...",
    "passFail": "Pass / fail",
    "yesNo": "Yes / no",
    "criticalHighIncidents": "Critical/high incidents",
    "addFollowUpAction": "Add follow-up action",
    "noExpiryRecorded": "No expiry recorded",
    "expiresToday": "Expires today",
    "healthy": "Healthy",
    "atRisk": "At risk",
    "noDateSet": "No date set",
    "affectedPersonNumber": "Affected person {number}",
    "existingAffectedPersonNumber": "Affected person {number} (existing)",
    "removeAssignee": "Remove {name}",
    "assignee": "assignee",
    "openCertificationActions": "Open actions for {name}",
    "showingCalendarItems": "Showing 3 of {count}",
    "calendarItemsOne": "{count} item sorted newest first.",
    "calendarItemsOther": "{count} items sorted newest first.",
    "dueOn": "Due {date}",
    "actionDescriptionDue": "{description} · due {date}",
    "nextDueOn": "Next due {date}",
    "runDescription": "{template} · {category} · Due {date}",
    "assignedToNames": "Assigned to: {names}",
    "assignedCount": "{count} assigned",
    "openActionCount": "{count} open",
    "automaticFrequency": "{frequency} · Auto",
    "starterExamples": "Start with club-friendly examples like Fire Safety Check, First Aid Kit Check, Kitchen Opening Check, Pool Safety Check, Golf Course Machinery Check, Clubhouse Walkthrough.",
    "expiryOverdueOne": "{count} day overdue",
    "expiryOverdueOther": "{count} days overdue",
    "expiryRemainingOne": "{count} day remaining",
    "expiryRemainingOther": "{count} days remaining",
    "highCriticalCount": "{count} high/critical",
    "dueInSevenDays": "{count} due in 7 days",
    "expiredCount": "{count} expired",
    "riskActionCounts": "{high} high · {actions} actions",
    "activity": "Safety activity",
    "certificationExpires": "{name} · Expires {date}",
    "moreCertifications": "+{count} more",
    "moveItemUp": "Move item up",
    "moveItemDown": "Move item down",
    "dateFrom": "From date",
    "dateTo": "To date",
    "cancelForm": "Cancel form",
    "slipTripOrFall": "Slip, Trip or Fall",
    "cutOrLaceration": "Cut or Laceration",
    "burn": "Burn",
    "allergicReaction": "Allergic Reaction",
    "foodPoisoning": "Food Poisoning",
    "equipmentRelatedInjury": "Equipment-Related Injury",
    "drowningNearDrowning": "Drowning/Near Drowning",
    "fire": "Fire",
    "flood": "Flood",
    "gasLeak": "Gas Leak",
    "powerOutage": "Power Outage",
    "structuralDamage": "Structural Damage",
    "chemicalSpill": "Chemical Spill",
    "securityBreach": "Security Breach",
    "theft": "Theft",
    "vandalism": "Vandalism",
    "minorNoMedicalAttentionRequired": "Minor - No medical attention required",
    "moderateFirstAidAdministered": "Moderate - First aid administered",
    "seriousMedicalAttentionRequired": "Serious - Medical attention required",
    "criticalEmergencyServicesCalled": "Critical - Emergency services called",
    "updateSafetyIncidentReport": "Update Safety Incident Report",
    "newSafetyIncidentReport": "New Safety Incident Report",
    "typeOfIncident": "Type of Incident *",
    "severityLevel": "Severity Level *",
    "locationOfIncident": "Location of Incident *",
    "eGPoolDeckMainDiningRoomTennisCourt1": "e.g., Pool deck, Main dining room, Tennis court 1",
    "detailedDescription": "Detailed Description *",
    "describeWhatHappenedHowItHappenedAndAnyContributingFactors": "Describe what happened, how it happened, and any contributing factors...",
    "injuredAffectedPerson": "Injured/Affected Person",
    "fullNameOfInjuredPerson": "Full name of injured person",
    "personTypeLegacy": "Person Type",
    "clubMember": "Club Member",
    "memberGuest": "Member Guest",
    "staffMemberLegacy": "Staff Member *",
    "enterWitnessName": "Enter witness name",
    "immediateActionTaken": "Immediate Action Taken *",
    "describeTheImmediateResponseFirstAidGivenAreaSecuredEtc": "Describe the immediate response, first aid given, area secured, etc.",
    "medicalAttentionRequired": "Medical attention required",
    "emergencyServicesCalled": "Emergency services called",
    "reportedToAuthorities": "Reported to authorities",
    "photosTakenOfScene": "Photos taken of scene",
    "followUpActionRequired": "Follow-up action required",
    "updateReport": "Update Report",
    "submitIncidentReport": "Submit Incident Report",
    "cPRCardiopulmonaryResuscitation": "CPR (Cardiopulmonary Resuscitation)",
    "firstAidLegacy": "First Aid",
    "aEDAutomatedExternalDefibrillator": "AED (Automated External Defibrillator)",
    "lifeguardCertification": "Lifeguard Certification",
    "waterSafetyInstructor": "Water Safety Instructor",
    "poolOperatorCertification": "Pool Operator Certification",
    "foodSafetyServSafe": "Food Safety/ServSafe",
    "foodHandlerCertificate": "Food Handler Certificate",
    "allergenAwareness": "Allergen Awareness",
    "fireSafetyTraining": "Fire Safety Training",
    "fireExtinguisherTraining": "Fire Extinguisher Training",
    "emergencyResponseTraining": "Emergency Response Training",
    "workplaceSafetyOSHA": "Workplace Safety (OSHA)",
    "hazardousMaterialsHandling": "Hazardous Materials Handling",
    "chemicalSafetyTraining": "Chemical Safety Training",
    "electricalSafety": "Electrical Safety",
    "forkliftOperation": "Forklift Operation",
    "defensiveDriving": "Defensive Driving",
    "securityTraining": "Security Training",
    "incidentCommandSystemICS": "Incident Command System (ICS)",
    "bloodbornePathogensTraining": "Bloodborne Pathogens Training",
    "confinedSpaceEntry": "Confined Space Entry",
    "fallProtection": "Fall Protection",
    "personalProtectiveEquipmentPPE": "Personal Protective Equipment (PPE)",
    "riskAssessmentLegacy": "Risk Assessment",
    "emergencyActionPlanTraining": "Emergency Action Plan Training",
    "evacuationProcedures": "Evacuation Procedures",
    "childProtectionSafeguarding": "Child Protection/Safeguarding",
    "mentalHealthFirstAid": "Mental Health First Aid",
    "wildernessFirstAid": "Wilderness First Aid",
    "localFireDepartment": "Local Fire Department",
    "localHealthDepartment": "Local Health Department",
    "stateCertificationBoard": "State Certification Board",
    "professionalAssociation": "Professional Association",
    "trainingCompany": "Training Company",
    "updateStaffCertification": "Update Staff Certification",
    "addStaffCertification": "Add Staff Certification",
    "enterStaffMemberName": "Enter staff member name",
    "certificationType": "Certification Type *",
    "selectCertificationType": "Select certification type",
    "issuingOrganization": "Issuing Organization *",
    "selectIssuingOrganization": "Select issuing organization",
    "issueDateLegacy": "Issue Date *",
    "expiryDateLegacy": "Expiry Date *",
    "certificateDocument": "Certificate Document",
    "clickToUploadCertificateOrDragAndDrop": "Click to upload certificate or drag and drop",
    "pDFJPGPNGUpTo10MB": "PDF, JPG, PNG up to 10MB",
    "certificateUploaded": "✓ Certificate uploaded: {file}",
    "updateCertification": "Update Certification",
    "staffMemberTitle": "Staff Member",
    "highCriticalOne": "{count} high/critical",
    "highCriticalOther": "{count} high/critical",
    "dueSevenOne": "{count} due in 7 days",
    "dueSevenOther": "{count} due in 7 days",
    "expiredOne": "{count} expired",
    "expiredOther": "{count} expired",
    "openActionOne": "{count} open",
    "openActionOther": "{count} open",
    "assignedOne": "{count} assigned",
    "assignedOther": "{count} assigned",
    "riskActionOneOne": "{high} high · {actions} actions",
    "riskActionOneOther": "{high} high · {actions} actions",
    "riskActionOtherOne": "{high} high · {actions} actions",
    "riskActionOtherOther": "{high} high · {actions} actions",
    "affectedPeopleHelp": "Add each member, staff member, guest, visitor, contractor, or other person affected by the incident.",
    "incidentDescriptionPlaceholder": "What happened? Keep it factual and club-friendly.",
    "attachmentUploadHelp": "Images, PDFs, Word documents, text files, and CSV files up to 25MB are supported.",
    "closeIncidentConfirmation": "Close this incident? You can still view the record and audit history.",
    "incidentFormHelp": "Capture the essentials now; investigation notes and follow-up can grow over time.",
    "incidentRegisterHelp": "A secure club accident book for incidents, near misses, follow-up actions, and audit history.",
    "incidentEmptyHelp": "Try clearing filters, or create the first incident when something needs recording.",
    "certificationFormHelp": "Keep staff qualifications and contractor compliance documents in one secure register.",
    "renewalNotesPlaceholder": "Useful renewal notes, restrictions, or evidence checks.",
    "certificateUploadHelp": "Accepted: images, PDFs, Word documents, text and CSV files up to 25MB. Files are stored privately and opened with signed links.",
    "certificationRegisterHelp": "Track first aid, fire marshal, food hygiene, safeguarding, DBS, contractor insurance, RAMS and other compliance records.",
    "archiveCertificationConfirmation": "Archive this certification? It will be hidden from active compliance views but retained for audit history.",
    "templateFormHelp": "Build a repeatable club safety check with practical response fields and evidence rules.",
    "recurringReminderHelp": "Assigned staff will receive an email and Privana notification 24 hours before each scheduled run is due.",
    "adHocScheduleHelp": "Ad hoc templates are only run manually. Choose Daily, Weekly, Monthly, Quarterly or Annually to enable automatic scheduling.",
    "startRunHelp": "Select a template, assignees and due date for this check.",
    "riskFormHelp": "Capture the hazard, controls and review rhythm in plain language.",
    "documentStorageHelp": "Private document storage with signed preview and download links.",
    "checklistRegisterHelp": "Templates, live checks, risk reviews, documents and upcoming compliance dates for your club.",
    "archiveRecordHelp": "This will hide it from active views but retain it for audit history.",
    "dashboardUpToDateHelp": "Your incidents, certifications, checklist runs, risks and documents are currently up to date.",
    "dbs": "DBS",
    "coshh": "COSHH",
    "rams": "RAMS",
    "cctv": "CCTV",
    "teamMember": "Team member",
    "memberNumber": "Member #{number}"
  },
  "enums": {
    "accident": "Accident",
    "near_miss": "Near miss",
    "property_damage": "Property damage",
    "member_complaint": "Member complaint",
    "safeguarding_concern": "Safeguarding concern",
    "security_incident": "Security incident",
    "vehicle_incident": "Vehicle incident",
    "environmental_incident": "Environmental incident",
    "other": "Other",
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "critical": "Critical",
    "open": "Open",
    "investigating": "Investigating",
    "awaiting_action": "Awaiting action",
    "closed": "Closed",
    "member": "Member",
    "staff": "Staff",
    "contractor": "Contractor",
    "visitor": "Visitor",
    "guest": "Guest",
    "in_progress": "In progress",
    "completed": "Completed",
    "cancelled": "Cancelled",
    "photo": "Photo",
    "document": "Document",
    "witness_statement": "Witness statement",
    "medical": "Medical",
    "cctv": "CCTV",
    "first_aid": "First aid",
    "fire_marshal": "Fire marshal",
    "food_hygiene": "Food hygiene",
    "safeguarding": "Safeguarding",
    "dbs": "DBS",
    "pool_plant": "Pool plant",
    "health_safety": "Health & safety",
    "coshh": "COSHH",
    "manual_handling": "Manual handling",
    "grounds_maintenance": "Grounds maintenance",
    "pesticide_application": "Pesticide application",
    "machinery": "Machinery",
    "insurance": "Insurance",
    "rams": "RAMS",
    "method_statement": "Method statement",
    "risk_assessment": "Risk assessment",
    "custom": "Custom",
    "valid": "Active",
    "expiring_soon": "Expiring Soon",
    "expired": "Expired",
    "missing_expiry": "Missing Expiry",
    "archived": "Archived",
    "certificate": "Certificate",
    "fire_safety": "Fire safety",
    "kitchen": "Kitchen",
    "clubhouse": "Clubhouse",
    "golf_course": "Golf course",
    "pool": "Pool",
    "gym": "Gym",
    "maintenance": "Maintenance",
    "housekeeping": "Housekeeping",
    "security": "Security",
    "general": "General",
    "ad_hoc": "Ad hoc",
    "daily": "Daily",
    "weekly": "Weekly",
    "monthly": "Monthly",
    "quarterly": "Quarterly",
    "annually": "Annually",
    "text": "Text",
    "number": "Number",
    "signature": "Signature",
    "policy": "Policy",
    "procedure": "Procedure",
    "emergency_plan": "Emergency plan",
    "fire_plan": "Fire plan",
    "templates": "Templates",
    "runs": "Checklist Runs",
    "risks": "Risk Assessments",
    "documents": "Documents",
    "calendar": "Compliance Calendar",
    "draft": "draft",
    "review_due": "review due",
    "scheduled_checklist": "Scheduled Checklist",
    "checklist_run": "checklist run",
    "checklist": "Checklist",
    "incident": "Incident",
    "risk": "Risk",
    "safety_document": "Safety Document",
    "evidence": "evidence",
    "inactive": "inactive",
    "blocked": "blocked"
  },
  "audit": {
    "incident_created": "incident created",
    "incident_updated": "incident updated",
    "incident_closed": "incident closed",
    "certification_created": "certification created",
    "certification_updated": "certification updated",
    "certification_archived": "certification archived",
    "person_added": "person added",
    "person_updated": "person updated",
    "person_removed": "person removed",
    "witness_added": "witness added",
    "witness_updated": "witness updated",
    "witness_removed": "witness removed",
    "action_added": "action added",
    "action_updated": "action updated",
    "action_cancelled": "action cancelled",
    "attachment_added": "attachment added",
    "attachment_uploaded": "attachment uploaded",
    "attachment_removed": "attachment removed",
    "created": "created",
    "updated": "updated",
    "archived": "archived",
    "cancelled": "cancelled",
    "completed": "completed",
    "item_added": "item added",
    "item_updated": "item updated",
    "item_removed": "item removed",
    "item_completed": "item completed",
    "schedule_recalculated": "schedule recalculated",
    "scheduled_run_created": "scheduled run created"
  },
  "errors": {
    "unknown": "Unable to complete this safety request. Please try again.",
    "server_error": "Unable to complete this safety request. Please try again.",
    "validation_error": "Please check the required fields, dates, scores and evidence before continuing.",
    "not_found": "This safety record or file is no longer available.",
    "run_locked": "This checklist run is read-only. Completed or cancelled runs cannot be changed.",
    "invalid_upload": "Select a valid file to upload.",
    "file_too_large": "Attachment files must be 25MB or smaller.",
    "unsupported_file_type": "Upload an image, PDF, Word document, text file, or CSV.",
    "upload_storage_unavailable": "Safety attachment storage is not available. Please contact support.",
    "unauthorized": "Sign in to access Safety.",
    "forbidden": "You do not have permission to perform this safety action.",
    "timeout": "The safety request timed out. Please try again.",
    "network_error": "Unable to connect to Safety. Check your connection and try again.",
    "invalid_json": "The safety response could not be read. Please try again."
  },
  "generated": {
    "overdueChecklist": "Overdue checklist: {name}",
    "expiredCertification": "Expired certification: {name}",
    "riskReviewDue": "Risk review due: {name}",
    "documentReviewDue": "Document review due: {name}",
    "checklistDueSoon": "Checklist due soon: {name}",
    "certificationExpiresSoon": "Certification expires soon: {name}",
    "incidentSeverity": "{severity} severity open incident",
    "viewIncident": "View incident",
    "reviewCertificate": "Review certificate",
    "reviewRisk": "Review risk",
    "reviewDocument": "Review document",
    "openCalendar": "Open calendar",
    "openRun": "Open run",
    "incidentUpdated": "Incident updated",
    "certificationUpdated": "Certification updated",
    "safetyItemUpdated": "Safety item updated",
    "activity_incident_created_incident": "Incident Created incident",
    "activity_incident_updated_incident": "Incident Updated incident",
    "activity_incident_closed_incident": "Incident Closed incident",
    "activity_certification_created_incident": "Certification Created incident",
    "activity_certification_updated_incident": "Certification Updated incident",
    "activity_certification_archived_incident": "Certification Archived incident",
    "activity_person_added_incident": "Person Added incident",
    "activity_person_updated_incident": "Person Updated incident",
    "activity_person_removed_incident": "Person Removed incident",
    "activity_witness_added_incident": "Witness Added incident",
    "activity_witness_updated_incident": "Witness Updated incident",
    "activity_witness_removed_incident": "Witness Removed incident",
    "activity_action_added_incident": "Action Added incident",
    "activity_action_updated_incident": "Action Updated incident",
    "activity_action_cancelled_incident": "Action Cancelled incident",
    "activity_attachment_added_incident": "Attachment Added incident",
    "activity_attachment_uploaded_incident": "Attachment Uploaded incident",
    "activity_attachment_removed_incident": "Attachment Removed incident",
    "activity_created_incident": "Created incident",
    "activity_updated_incident": "Updated incident",
    "activity_archived_incident": "Archived incident",
    "activity_cancelled_incident": "Cancelled incident",
    "activity_completed_incident": "Completed incident",
    "activity_item_added_incident": "Item Added incident",
    "activity_item_updated_incident": "Item Updated incident",
    "activity_item_removed_incident": "Item Removed incident",
    "activity_item_completed_incident": "Item Completed incident",
    "activity_schedule_recalculated_incident": "Schedule Recalculated incident",
    "activity_scheduled_run_created_incident": "Scheduled Run Created incident",
    "activity_incident_created_certification": "Incident Created certification",
    "activity_incident_updated_certification": "Incident Updated certification",
    "activity_incident_closed_certification": "Incident Closed certification",
    "activity_certification_created_certification": "Certification Created certification",
    "activity_certification_updated_certification": "Certification Updated certification",
    "activity_certification_archived_certification": "Certification Archived certification",
    "activity_person_added_certification": "Person Added certification",
    "activity_person_updated_certification": "Person Updated certification",
    "activity_person_removed_certification": "Person Removed certification",
    "activity_witness_added_certification": "Witness Added certification",
    "activity_witness_updated_certification": "Witness Updated certification",
    "activity_witness_removed_certification": "Witness Removed certification",
    "activity_action_added_certification": "Action Added certification",
    "activity_action_updated_certification": "Action Updated certification",
    "activity_action_cancelled_certification": "Action Cancelled certification",
    "activity_attachment_added_certification": "Attachment Added certification",
    "activity_attachment_uploaded_certification": "Attachment Uploaded certification",
    "activity_attachment_removed_certification": "Attachment Removed certification",
    "activity_created_certification": "Created certification",
    "activity_updated_certification": "Updated certification",
    "activity_archived_certification": "Archived certification",
    "activity_cancelled_certification": "Cancelled certification",
    "activity_completed_certification": "Completed certification",
    "activity_item_added_certification": "Item Added certification",
    "activity_item_updated_certification": "Item Updated certification",
    "activity_item_removed_certification": "Item Removed certification",
    "activity_item_completed_certification": "Item Completed certification",
    "activity_schedule_recalculated_certification": "Schedule Recalculated certification",
    "activity_scheduled_run_created_certification": "Scheduled Run Created certification",
    "activity_incident_created_checklist_run": "Incident Created checklist run",
    "activity_incident_updated_checklist_run": "Incident Updated checklist run",
    "activity_incident_closed_checklist_run": "Incident Closed checklist run",
    "activity_certification_created_checklist_run": "Certification Created checklist run",
    "activity_certification_updated_checklist_run": "Certification Updated checklist run",
    "activity_certification_archived_checklist_run": "Certification Archived checklist run",
    "activity_person_added_checklist_run": "Person Added checklist run",
    "activity_person_updated_checklist_run": "Person Updated checklist run",
    "activity_person_removed_checklist_run": "Person Removed checklist run",
    "activity_witness_added_checklist_run": "Witness Added checklist run",
    "activity_witness_updated_checklist_run": "Witness Updated checklist run",
    "activity_witness_removed_checklist_run": "Witness Removed checklist run",
    "activity_action_added_checklist_run": "Action Added checklist run",
    "activity_action_updated_checklist_run": "Action Updated checklist run",
    "activity_action_cancelled_checklist_run": "Action Cancelled checklist run",
    "activity_attachment_added_checklist_run": "Attachment Added checklist run",
    "activity_attachment_uploaded_checklist_run": "Attachment Uploaded checklist run",
    "activity_attachment_removed_checklist_run": "Attachment Removed checklist run",
    "activity_created_checklist_run": "Created checklist run",
    "activity_updated_checklist_run": "Updated checklist run",
    "activity_archived_checklist_run": "Archived checklist run",
    "activity_cancelled_checklist_run": "Cancelled checklist run",
    "activity_completed_checklist_run": "Completed checklist run",
    "activity_item_added_checklist_run": "Item Added checklist run",
    "activity_item_updated_checklist_run": "Item Updated checklist run",
    "activity_item_removed_checklist_run": "Item Removed checklist run",
    "activity_item_completed_checklist_run": "Item Completed checklist run",
    "activity_schedule_recalculated_checklist_run": "Schedule Recalculated checklist run",
    "activity_scheduled_run_created_checklist_run": "Scheduled Run Created checklist run",
    "activity_incident_created_checklist_template": "Incident Created checklist template",
    "activity_incident_updated_checklist_template": "Incident Updated checklist template",
    "activity_incident_closed_checklist_template": "Incident Closed checklist template",
    "activity_certification_created_checklist_template": "Certification Created checklist template",
    "activity_certification_updated_checklist_template": "Certification Updated checklist template",
    "activity_certification_archived_checklist_template": "Certification Archived checklist template",
    "activity_person_added_checklist_template": "Person Added checklist template",
    "activity_person_updated_checklist_template": "Person Updated checklist template",
    "activity_person_removed_checklist_template": "Person Removed checklist template",
    "activity_witness_added_checklist_template": "Witness Added checklist template",
    "activity_witness_updated_checklist_template": "Witness Updated checklist template",
    "activity_witness_removed_checklist_template": "Witness Removed checklist template",
    "activity_action_added_checklist_template": "Action Added checklist template",
    "activity_action_updated_checklist_template": "Action Updated checklist template",
    "activity_action_cancelled_checklist_template": "Action Cancelled checklist template",
    "activity_attachment_added_checklist_template": "Attachment Added checklist template",
    "activity_attachment_uploaded_checklist_template": "Attachment Uploaded checklist template",
    "activity_attachment_removed_checklist_template": "Attachment Removed checklist template",
    "activity_created_checklist_template": "Created checklist template",
    "activity_updated_checklist_template": "Updated checklist template",
    "activity_archived_checklist_template": "Archived checklist template",
    "activity_cancelled_checklist_template": "Cancelled checklist template",
    "activity_completed_checklist_template": "Completed checklist template",
    "activity_item_added_checklist_template": "Item Added checklist template",
    "activity_item_updated_checklist_template": "Item Updated checklist template",
    "activity_item_removed_checklist_template": "Item Removed checklist template",
    "activity_item_completed_checklist_template": "Item Completed checklist template",
    "activity_schedule_recalculated_checklist_template": "Schedule Recalculated checklist template",
    "activity_scheduled_run_created_checklist_template": "Scheduled Run Created checklist template",
    "activity_incident_created_risk_assessment": "Incident Created risk assessment",
    "activity_incident_updated_risk_assessment": "Incident Updated risk assessment",
    "activity_incident_closed_risk_assessment": "Incident Closed risk assessment",
    "activity_certification_created_risk_assessment": "Certification Created risk assessment",
    "activity_certification_updated_risk_assessment": "Certification Updated risk assessment",
    "activity_certification_archived_risk_assessment": "Certification Archived risk assessment",
    "activity_person_added_risk_assessment": "Person Added risk assessment",
    "activity_person_updated_risk_assessment": "Person Updated risk assessment",
    "activity_person_removed_risk_assessment": "Person Removed risk assessment",
    "activity_witness_added_risk_assessment": "Witness Added risk assessment",
    "activity_witness_updated_risk_assessment": "Witness Updated risk assessment",
    "activity_witness_removed_risk_assessment": "Witness Removed risk assessment",
    "activity_action_added_risk_assessment": "Action Added risk assessment",
    "activity_action_updated_risk_assessment": "Action Updated risk assessment",
    "activity_action_cancelled_risk_assessment": "Action Cancelled risk assessment",
    "activity_attachment_added_risk_assessment": "Attachment Added risk assessment",
    "activity_attachment_uploaded_risk_assessment": "Attachment Uploaded risk assessment",
    "activity_attachment_removed_risk_assessment": "Attachment Removed risk assessment",
    "activity_created_risk_assessment": "Created risk assessment",
    "activity_updated_risk_assessment": "Updated risk assessment",
    "activity_archived_risk_assessment": "Archived risk assessment",
    "activity_cancelled_risk_assessment": "Cancelled risk assessment",
    "activity_completed_risk_assessment": "Completed risk assessment",
    "activity_item_added_risk_assessment": "Item Added risk assessment",
    "activity_item_updated_risk_assessment": "Item Updated risk assessment",
    "activity_item_removed_risk_assessment": "Item Removed risk assessment",
    "activity_item_completed_risk_assessment": "Item Completed risk assessment",
    "activity_schedule_recalculated_risk_assessment": "Schedule Recalculated risk assessment",
    "activity_scheduled_run_created_risk_assessment": "Scheduled Run Created risk assessment",
    "activity_incident_created_safety_document": "Incident Created safety document",
    "activity_incident_updated_safety_document": "Incident Updated safety document",
    "activity_incident_closed_safety_document": "Incident Closed safety document",
    "activity_certification_created_safety_document": "Certification Created safety document",
    "activity_certification_updated_safety_document": "Certification Updated safety document",
    "activity_certification_archived_safety_document": "Certification Archived safety document",
    "activity_person_added_safety_document": "Person Added safety document",
    "activity_person_updated_safety_document": "Person Updated safety document",
    "activity_person_removed_safety_document": "Person Removed safety document",
    "activity_witness_added_safety_document": "Witness Added safety document",
    "activity_witness_updated_safety_document": "Witness Updated safety document",
    "activity_witness_removed_safety_document": "Witness Removed safety document",
    "activity_action_added_safety_document": "Action Added safety document",
    "activity_action_updated_safety_document": "Action Updated safety document",
    "activity_action_cancelled_safety_document": "Action Cancelled safety document",
    "activity_attachment_added_safety_document": "Attachment Added safety document",
    "activity_attachment_uploaded_safety_document": "Attachment Uploaded safety document",
    "activity_attachment_removed_safety_document": "Attachment Removed safety document",
    "activity_created_safety_document": "Created safety document",
    "activity_updated_safety_document": "Updated safety document",
    "activity_archived_safety_document": "Archived safety document",
    "activity_cancelled_safety_document": "Cancelled safety document",
    "activity_completed_safety_document": "Completed safety document",
    "activity_item_added_safety_document": "Item Added safety document",
    "activity_item_updated_safety_document": "Item Updated safety document",
    "activity_item_removed_safety_document": "Item Removed safety document",
    "activity_item_completed_safety_document": "Item Completed safety document",
    "activity_schedule_recalculated_safety_document": "Schedule Recalculated safety document",
    "activity_scheduled_run_created_safety_document": "Scheduled Run Created safety document",
    "activity_incident_closed": "Incident closed",
    "activity_incident_created": "Incident created",
    "activity_certification_updated": "Certification updated",
    "activity_checklist_completed": "Checklist completed",
    "activity_checklist_run_created": "Checklist run created",
    "activity_risk_assessment_updated": "Risk assessment updated",
    "activity_document_archived": "Document archived",
    "activity_document_uploaded": "Document uploaded"
  },
  "reminders": {
    "recipient": "there",
    "subject": "Checklist due tomorrow: {name}",
    "hello": "Hello {name},",
    "checklist": "Checklist: {name}",
    "due": "Due: {date}",
    "area": "Area/department: {area}",
    "category": "Category: {category}",
    "instructions": "This checklist is due soon. Please complete it in the Privana portal and refer to the checklist record for full details.",
    "openLink": "Open Checklist in Privana: {url}",
    "open": "Open Checklist in Privana",
    "logo": "Club logo",
    "dueSentence": "{name} is due {date}.",
    "title": "Checklist due tomorrow",
    "body": "{name} is due {date}. Open Privana to complete it."
  }
};
